import React from 'react';
import { Icon, Popconfirm, Tooltip } from 'antd';
import { useAttachment } from '../../providers/attachment';
import { CardIconButton } from '../../../Card';
import styles from './index.module.scss';

const ActionsSlot = ({ onEdit, onRemove, children }) => {
  const attachment = useAttachment();

  return (
    <div className={styles.root}>
      {children}

      {typeof onEdit === 'function' && <Edit onEdit={onEdit} />}

      {typeof onRemove === 'function' && <Remove onConfirm={onRemove} />}
    </div>
  );
};

export default ActionsSlot;

function Edit({ onEdit }) {
  return (
    <Tooltip title="Изменить" placement="bottomRight">
      <CardIconButton
        onClick={onEdit}
        renderIcon={() => <Icon type="edit" />}
      />
    </Tooltip>
  );
}

function Remove({ onConfirm }) {
  if (typeof onConfirm !== 'function') return null;

  return (
    <Tooltip title="Удалить" placement="bottomRight">
      <CardIconButton
        renderIcon={() => <Icon type="close-circle" />}
        onClick={onConfirm}
      />
    </Tooltip>
  );

  // return (
  //   <Popconfirm
  //     cancelText="Нет"
  //     okText="Да"
  //     onConfirm={onConfirm}
  //     title="Удалить файл?"
  //     placement="topRight"
  //   >
  //     <Tooltip title="Удалить" placement="bottomRight">
  //       <CardIconButton renderIcon={() => <Icon type="close-circle" />} />
  //     </Tooltip>
  //   </Popconfirm>
  // );
}
